import http from '../http-common';

class EmailTemplateService {
  getAll() {
    return http.get('/email-templates');
  }

  get(id) {
    return http.get(`/email-templates/${id}`);
  }

  create(data) {
    return http.post('/email-templates', data);
  }

  update(id, data) {
    return http.put(`/email-templates/${id}`, data);
  }

  delete(id) {
    return http.delete(`/email-templates/${id}`);
  }

  preview(id) {
    return http.get(`/email-templates/${id}/preview`);
  }

  sendTest(id, email) {
    return http.post(`/email-templates/${id}/test`, { email });
  }

  getVariables(type = 'anniversary') {
    return http.get(`/email-templates/variables?type=${type}`);
  }
}

export default new EmailTemplateService();
